import { render, staticRenderFns } from "./NxPhoneInput.vue?vue&type=template&id=6c360596&scoped=true&"
import script from "./NxPhoneInput.vue?vue&type=script&lang=js&"
export * from "./NxPhoneInput.vue?vue&type=script&lang=js&"
import style0 from "./NxPhoneInput.vue?vue&type=style&index=0&id=6c360596&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c360596",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src3744633428/src/vbc-messaging-10-dlc-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c360596')) {
      api.createRecord('6c360596', component.options)
    } else {
      api.reload('6c360596', component.options)
    }
    module.hot.accept("./NxPhoneInput.vue?vue&type=template&id=6c360596&scoped=true&", function () {
      api.rerender('6c360596', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/NxPhoneInput.vue"
export default component.exports